var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VContainer',{attrs:{"fill-height":""}},[_c('VFlex',{staticClass:"text-center"},[_c('GhostCar',{attrs:{"width":"200"}}),_c('div',{staticClass:"text-h5 mt-6 mb-4"},[_vm._v(" This vehicle is no longer available ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }